import { useRef } from "react";

import { LoadingSpinner } from "@newsela/angelou";
import PropTypes from "prop-types";

import CheckIcon from "@/icons/CheckIcon";
import ActivityErrorMessage from "../ActivityErrorMessage";
import QuestionFlagForm from "../QuestionFlagForm";
import {
  checkIconCss,
  confirmationMessageCss,
  iconContainerCss,
} from "./QuestionFlagContainer.style";

const propTypes = {
  activityType: PropTypes.string,
  displayErrorMessage: PropTypes.bool,
  handleChange: PropTypes.func,
  isRequestLoading: PropTypes.bool,
  isRequestSuccessful: PropTypes.bool,
  selectedFlag: PropTypes.string,
};

const QUIZ_QUESTION_OPTIONS = [
  "No correct answer",
  "Not aligned with standard/reading skill",
  "Grammar and punctuation errors",
  "Incorrect answer",
  "More than one correct answer",
];

const QuestionFlagContainer = ({
  activityType,
  displayErrorMessage,
  handleChange,
  isRequestLoading,
  isRequestSuccessful,
  selectedFlag,
}) => {
  const errorRef = useRef();
  const renderConfirmationMessage = () => {
    return (
      <div role="alert" css={confirmationMessageCss}>
        <div css={iconContainerCss}>
          <CheckIcon css={checkIconCss} />
        </div>
        <p>
          Thank you for the feedback. This question will be reviewed shortly.
        </p>
      </div>
    );
  };

  const errorMessageText = "Select a reason";

  return (
    <>
      {isRequestLoading && <LoadingSpinner />}
      {!isRequestSuccessful && !isRequestLoading && (
        <QuestionFlagForm
          handleChange={handleChange}
          options={activityType === "quiz" ? QUIZ_QUESTION_OPTIONS : []}
          selectedFlag={selectedFlag}
        />
      )}
      {!selectedFlag && displayErrorMessage && (
        <ActivityErrorMessage message={errorMessageText} ref={errorRef} />
      )}
      {isRequestSuccessful && renderConfirmationMessage()}
    </>
  );
};

QuestionFlagContainer.propTypes = propTypes;

export default QuestionFlagContainer;
